// extracted by mini-css-extract-plugin
module.exports = {"button":"OpenCloseButton_button__cKZWq","buttonContent":"OpenCloseButton_buttonContent__E9HRp"};